import React from 'react';


const a = {
    fill: '#90cae4'
};
    
const b = {
    fill: '#e6e6e6'
};
    
const c ={
    fill: '#e6e6e6',
    opacity: 0.51
};
    
const d = {
    fill: '#b0c6c6'
};

const e = {
    fill: '#cce1e2'
};
    
const f = {
    fill: '#b3b3b3'
};
    
const g = {
    fill: '#5f7a2a'
};

const h = {
    fill: '#7dad31'
};

const i = {
    fill: '#66332a'
};
    
const j = {
    fill: '#f2f2f2'
};

const k = {
    fill: '#4c2f2c'
};

const l = {
    fill: '#ccbcb2'
};

const m = {
    fill: '#35373d'
};

const n = {
    fill: '#121622'
};

const o = {
    fill: '#892b2b'
};

const p = {
    fill: '#d42a28'
};

const q = {
    fill: '#6a4b40'
};

const r = {
    fill: '#faf7f2'
};

const s = {
    fill: '#e07027'
};

const t = {
    fill: '#d38c8c'
};

const u = {
    fill:' #27583a'
};

const v = {
    fill: '#c2b9af'
};

const w = {
    fill: '#261e1f'
};

const x = {
    fill: '#645051'
};

const y = {
    fill: '#c09072'
};

const z = {
    opacity: 0.62,
    fill: 'url(#seehi-gradient)'
};

const aa = {
    fill: 'none'
};

const ab = {
    fill: '#3d3233'
};

// const getClouds = function(count=6){
//     // <path style={b} d="M378,229.15a28.25,28.25,0,0,0-15.32,4.48,36.46,36.46,0,0,0-65.57-.15,28.44,28.44,0,0,0-41,12.34,18.09,18.09,0,0,0-26.06,11.88H406.41v-.15A28.39,28.39,0,0,0,378,229.15Z"/>
//     // <path style={b} d="M1200,271.6a28.25,28.25,0,0,0-15.32,4.48,36.47,36.47,0,0,0-65.58-.15,28.42,28.42,0,0,0-41,12.34,18.09,18.09,0,0,0-26.06,11.88h176.32V300A28.39,28.39,0,0,0,1200,271.6Z"/>
//     // <path style={b} d="M631.8,271.58a28.25,28.25,0,0,0-15.32,4.48,36.46,36.46,0,0,0-65.57-.14,28.42,28.42,0,0,0-41,12.33,18.09,18.09,0,0,0-26.06,11.88H660.2V300A28.39,28.39,0,0,0,631.8,271.58Z"/>
//     // <path style={b} d="M795.21,229.15a28.22,28.22,0,0,0-15.32,4.48,36.47,36.47,0,0,0-65.58-.15,28.42,28.42,0,0,0-41,12.34,18.09,18.09,0,0,0-26.06,11.88H823.61v-.15A28.4,28.4,0,0,0,795.21,229.15Z"/>
//     // <path style={b} d="M171.87,181.45a28.25,28.25,0,0,0-15.32,4.48A36.46,36.46,0,0,0,91,185.78a28.44,28.44,0,0,0-41,12.34A18.09,18.09,0,0,0,24,210H200.27v-.15A28.39,28.39,0,0,0,171.87,181.45Z"/>
//     // <path style={b} d="M950.83,206.89a28.33,28.33,0,0,0-15.32,4.48,36.46,36.46,0,0,0-65.57-.14,28.41,28.41,0,0,0-41,12.34,18.07,18.07,0,0,0-26.06,11.88H979.23v-.16A28.4,28.4,0,0,0,950.83,206.89Z"/>
//     const clouds = [];
//     for(let i = 0; i < count; i++){
//         clouds.push(<Cloud x={(i+0.5)/6} key={i} />);
//     }
//     return clouds;
// }

function Header(props){
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1153 472" width="100%" style={{position: 'absolute', top: 0, overflow: 'hidden'}}>
        <defs>
        
        <linearGradient id="seehi-gradient" data-name="Naamloos verloop 54" x1="577" y1="218" x2="577" y2="-1" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#fff" stopOpacity="0"/>
            <stop offset="0.04" stopColor="#fff" stopOpacity="0.04"/>
            <stop offset="0.4" stopColor="#fff" stopOpacity="0.45"/>
            <stop offset="0.69" stopColor="#fff" stopOpacity="0.74"/>
            <stop offset="0.9" stopColor="#fff" stopOpacity="0.93"/>
            <stop offset="1" stopColor="#fff"/>
        </linearGradient>
        </defs>
        <title>header2</title>
        <path style={a} d="M573.76,13c303.29-1.94,509.62,83.22,583,218.37C1182.37,278.58-18.47,267.1-1,232,74.49,80.35,257.66,15.05,573.76,13Z"/>
        <rect style={a} x="-1.17" y="-14" width="1157.91" height="486.12"/>
        <g>
            {[[-270, 15],[0,-110],[200,-10],[350, -70],[780,30],[700,-65],[-100,-15]].map((pos, i) => (
                <g  className="seehi_cloud" id={'seehi_cloud'+(i+1)} key={i} transform={'translate('+pos[0]+', 0)'}>
                    <path transform={'translate(0, ' + pos[1]+')'} style={b} d="M378,229.15a28.25,28.25,0,0,0-15.32,4.48,36.46,36.46,0,0,0-65.57-.15,28.44,28.44,0,0,0-41,12.34,18.09,18.09,0,0,0-26.06,11.88H406.41v-.15A28.39,28.39,0,0,0,378,229.15Z"/>
                </g>
            ))}
        </g>
        <polygon style={c} points="496.46 336.09 496.46 293.57 449.98 293.57 449.98 439.37 496.46 439.37 542.93 439.37 542.93 336.09 496.46 336.09"/>
        <g>
            <g>
            <rect style={d} x="6.53" y="336.09" width="46.47" height="103.28"/>
            <rect style={d} x="392.11" y="269" width="46.47" height="170.37"/>
            <polygon style={d} points="299.77 207.46 299.77 275.1 253.29 275.1 253.29 336.09 219.37 336.09 219.37 266.53 172.9 266.53 172.9 439.37 219.37 439.37 253.29 439.37 265.85 439.37 299.77 439.37 346.24 439.37 346.24 207.46 299.77 207.46"/>
            </g>
            <g>
            <rect style={e} x="30.49" y="336.09" width="46.47" height="103.28"/>
            <rect style={e} x="413.07" y="269" width="46.47" height="170.37"/>
            <polygon style={e} points="323.73 207.46 323.73 275.1 277.25 275.1 277.25 336.09 243.33 336.09 243.33 266.53 196.86 266.53 196.86 439.37 243.33 439.37 277.25 439.37 289.81 439.37 323.73 439.37 370.2 439.37 370.2 207.46 323.73 207.46"/>
            </g>
        </g>
        <g>
            <g>
            <rect style={d} x="582.11" y="336.09" width="46.47" height="103.28"/>
            <rect style={d} x="1089.36" y="336.09" width="46.47" height="103.28"/>
            <polygon style={d} points="1029.02 207.46 1029.02 275.1 982.54 275.1 982.54 336.09 948.62 336.09 948.62 266.53 902.15 266.53 902.15 439.37 948.62 439.37 982.54 439.37 995.1 439.37 1029.02 439.37 1075.49 439.37 1075.49 207.46 1029.02 207.46"/>
            </g>
            <g>
            <rect style={e} x="607.42" y="336.09" width="46.47" height="103.28"/>
            <rect style={e} x="1113.32" y="336.09" width="46.47" height="103.28"/>
            <polygon style={e} points="1052.98 207.46 1052.98 275.1 1006.5 275.1 1006.5 336.09 972.58 336.09 972.58 266.53 926.11 266.53 926.11 439.37 972.58 439.37 1006.5 439.37 1019.06 439.37 1052.98 439.37 1099.45 439.37 1099.45 207.46 1052.98 207.46"/>
            </g>
        </g>
        <rect style={f} x="9.7" y="456.33" width="31.99" height="3.36"/>
        <g>
            <path style={g} d="M613.73,373.74h5.49c21.28,0,43.73-17.25,43.73-38.54l-5.19-81.81a38.54,38.54,0,0,0-38.54-38.54h-5.49a38.54,38.54,0,0,0-38.54,38.54L570,335.2C570,356.49,592.45,373.74,613.73,373.74Z"/>
            <rect style={h} x="575.19" y="206" width="82.57" height="158.9" rx="33.73" transform="translate(1232.95 570.9) rotate(180)"/>
            <path style={i} d="M616.47,408.59a2.46,2.46,0,0,0,2.47-2.47V275.43a2.47,2.47,0,1,0-4.93,0V406.12A2.46,2.46,0,0,0,616.47,408.59Z"/>
            <path style={i} d="M616.47,355.7a27,27,0,0,0,27-27v-8.52a2.47,2.47,0,0,0-4.93,0v8.52a22.1,22.1,0,0,1-22.08,22.08,2.46,2.46,0,0,0,0,4.92Z"/>
            <path style={i} d="M616.47,315.16a2.47,2.47,0,1,0,0-4.93,22.1,22.1,0,0,1-22.07-22.08v-8.51a2.47,2.47,0,1,0-4.93,0v8.51A27,27,0,0,0,616.47,315.16Z"/>
        </g>
        <rect style={f} x="85.7" y="456.33" width="31.99" height="3.36"/>
        <rect style={f} x="161.69" y="456.33" width="31.99" height="3.36"/>
        <rect style={f} x="237.69" y="456.33" width="31.99" height="3.36"/>
        <rect style={f} x="313.69" y="456.33" width="31.99" height="3.36"/>
        <rect style={f} x="389.69" y="456.33" width="31.99" height="3.36"/>
        <rect style={f} x="465.69" y="456.33" width="31.99" height="3.36"/>
        <rect style={f} x="541.69" y="456.33" width="31.99" height="3.36"/>
        <path style={h} d="M531.74,369a38.55,38.55,0,0,0-16.29-43.85,28,28,0,1,0-41,0A38.55,38.55,0,0,0,458.12,369a54.78,54.78,0,1,0,73.62,0Z"/>
        <g>
            <path style={g} d="M1134.34,400h5c19.3,0,39.64-15.64,39.64-34.94l-4.7-74.14A34.93,34.93,0,0,0,1139.31,256h-5A34.93,34.93,0,0,0,1099.41,291l-4.7,74.14C1094.71,384.39,1115.05,400,1134.34,400Z"/>
            <rect style={h} x="1099.41" y="248" width="74.83" height="144.01" rx="33.73" transform="translate(2273.66 640.01) rotate(180)"/>
            <path style={i} d="M1136.83,431.61a2.23,2.23,0,0,0,2.23-2.24V310.92a2.24,2.24,0,0,0-4.47,0V429.37A2.24,2.24,0,0,0,1136.83,431.61Z"/>
            <path style={i} d="M1136.83,383.68a24.5,24.5,0,0,0,24.47-24.48v-7.71a2.24,2.24,0,1,0-4.47,0v7.71a20,20,0,0,1-20,20,2.24,2.24,0,1,0,0,4.47Z"/>
            <path style={i} d="M1136.83,346.93a2.24,2.24,0,0,0,0-4.47,20,20,0,0,1-20-20v-7.72a2.24,2.24,0,1,0-4.47,0v7.72A24.5,24.5,0,0,0,1136.83,346.93Z"/>
        </g>
        <g>
            <path style={g} d="M35.73,400.13h4.48C57.61,400.13,76,386,76,368.64l-4.24-66.85a31.49,31.49,0,0,0-31.5-31.49H35.73A31.49,31.49,0,0,0,4.24,301.79L0,368.64C0,386,18.34,400.13,35.73,400.13Z"/>
            <rect style={h} x="4.24" y="263.07" width="67.47" height="129.83" rx="33.73" transform="translate(75.95 655.98) rotate(180)"/>
            <path style={i} d="M38,428.61a2,2,0,0,0,2-2V319.8a2,2,0,0,0-4,0V426.59A2,2,0,0,0,38,428.61Z"/>
            <path style={i} d="M38,385.39A22.09,22.09,0,0,0,60,363.33v-7a2,2,0,0,0-4,0v7a18.06,18.06,0,0,1-18,18,2,2,0,0,0,0,4Z"/>
            <path style={i} d="M38,352.26a2,2,0,1,0,0-4,18.06,18.06,0,0,1-18-18v-7a2,2,0,0,0-4,0v7A22.08,22.08,0,0,0,38,352.26Z"/>
        </g>
        <g>
            <rect style={j} x="523.71" y="359.71" width="91.9" height="80.08"/>
            <rect style={k} x="548.19" y="291.71" width="19.38" height="12.48"/>
            <polygon style={k} points="490.28 304.19 460.69 351.21 460.69 441.54 520.17 441.54 520.17 351.21 561.78 351.21 591.37 304.19 490.28 304.19"/>
            <polygon style={l} points="520.17 304.19 520.17 357.24 516.27 351.21 490.58 311.57 464.63 351.21 460.69 351.21 490.28 304.19 520.17 304.19"/>
            <path style={i} d="M520.17,355.49V439.8h60.09V410.24h5.58V439.8h3.74V410.24h20.16V439.8h11.52V355.49Zm69.41,9.8h20.16v14.16H589.58Zm-33.56,0h14.7v5.89H556Zm0,7.27h14.7v16.05H556ZM528,365.29H554.3v23.32H528Zm42.77,64.81H528V406.77h42.77Z"/>
            <rect style={l} x="460.69" y="351.2" width="3.95" height="6.03"/>
            <rect style={j} x="589.58" y="379.45" width="20.16" height="0.02"/>
            <polygon style={m} points="490.28 304.18 591.37 304.18 620.96 351.2 519.87 351.2 490.28 304.18"/>
            <rect style={n} x="577.46" y="406.77" width="34.53" height="3.46"/>
            <rect style={n} x="523.71" y="388.61" width="50.92" height="3.46"/>
            <rect style={n} x="586.84" y="379.45" width="25.61" height="3.46"/>
            <rect style={n} x="523.71" y="430.1" width="50.92" height="3.46"/>
            <rect style={i} x="561.81" y="291.71" width="19.38" height="12.48"/>
            <polygon style={i} points="573.48 289.09 568.95 289.09 558.23 289.09 558.23 291.71 568.95 291.71 573.48 291.71 584.2 291.71 584.2 289.09 573.48 289.09"/>
            <polygon style={k} points="553.06 289.09 550.88 289.09 545.7 289.09 545.7 291.71 550.88 291.71 553.06 291.71 558.23 291.71 558.23 289.09 553.06 289.09"/>
            <polygon style={l} points="621.26 397.65 521.03 397.65 520.17 397.65 460.69 397.65 460.69 403.68 521.03 403.68 521.03 403.67 621.26 403.67 621.26 397.65"/>
            <rect style={l} x="520.17" y="351.2" width="101.09" height="6.03"/>
        </g>
        <g>
            <rect style={j} x="419.71" y="359.71" width="91.9" height="80.08"/>
            <rect style={k} x="444.19" y="291.71" width="19.38" height="12.48"/>
            <polygon style={k} points="386.28 304.19 356.69 351.21 356.69 441.54 416.17 441.54 416.17 351.21 457.78 351.21 487.37 304.19 386.28 304.19"/>
            <polygon style={l} points="416.17 304.19 416.17 357.24 412.27 351.21 386.58 311.57 360.63 351.21 356.69 351.21 386.28 304.19 416.17 304.19"/>
            <path style={i} d="M416.17,355.49V439.8h60.09V410.24h5.58V439.8h3.74V410.24h20.16V439.8h11.52V355.49Zm69.41,9.8h20.16v14.16H485.58Zm-33.56,0h14.7v5.89H452Zm0,7.27h14.7v16.05H452ZM424,365.29H450.3v23.32H424Zm42.77,64.81H424V406.77h42.77Z"/>
            <rect style={l} x="356.69" y="351.2" width="3.95" height="6.03"/>
            <rect style={j} x="485.58" y="379.45" width="20.16" height="0.02"/>
            <polygon style={m} points="386.28 304.18 487.37 304.18 516.96 351.2 415.87 351.2 386.28 304.18"/>
            <rect style={n} x="473.46" y="406.77" width="34.53" height="3.46"/>
            <rect style={n} x="419.71" y="388.61" width="50.92" height="3.46"/>
            <rect style={n} x="482.84" y="379.45" width="25.61" height="3.46"/>
            <rect style={n} x="419.71" y="430.1" width="50.92" height="3.46"/>
            <rect style={i} x="457.81" y="291.71" width="19.38" height="12.48"/>
            <polygon style={i} points="469.48 289.09 464.95 289.09 454.23 289.09 454.23 291.71 464.95 291.71 469.48 291.71 480.2 291.71 480.2 289.09 469.48 289.09"/>
            <polygon style={k} points="449.06 289.09 446.88 289.09 441.7 289.09 441.7 291.71 446.88 291.71 449.06 291.71 454.23 291.71 454.23 289.09 449.06 289.09"/>
            <polygon style={l} points="517.26 397.65 417.03 397.65 416.17 397.65 356.69 397.65 356.69 403.68 417.03 403.68 417.03 403.67 517.26 403.67 517.26 397.65"/>
            <rect style={l} x="416.17" y="351.2" width="101.09" height="6.03"/>
        </g>
        <g>
            <polyline style={o} points="210.61 439.44 223.6 439.44 232.4 439.44 247.21 439.44 364.29 439.44 364.29 429.44 364.29 396.16 368.22 396.16 381.03 396.16 327 332.11 339.25 312.83 310.74 312.83 285.08 342.71 206.19 342.71"/>
            <polyline style={i} points="206.19 342.71 180.7 400.18 180.7 401.71 180.7 429.44 180.7 439.44 188.69 439.44 210.61 439.44"/>
            <g>
            <polygon style={p} points="409.55 396.16 392.8 396.16 314.45 368.14 314.45 400.18 206.19 400.18 206.19 342.71 313.59 342.71 339.25 312.83 409.55 396.16"/>
            <polygon style={q} points="396.73 396.16 392.8 396.16 392.8 429.44 209.22 429.44 209.22 401.71 280.54 401.71 280.54 397.55 339.22 327.69 396.73 396.16"/>
            <polygon style={l} points="392.8 396.16 392.8 429.44 209.22 429.44 209.22 399.97 285.19 399.97 285.19 396.16 339 332.11 392.8 396.16"/>
            <rect style={i} x="209.22" y="429.44" width="183.58" height="10"/>
            <path style={r} d="M234.66,404.21c-9.64,0-17.45,6.08-17.45,7.38v27.85h34.9V411.59C252.11,410.29,244.3,404.21,234.66,404.21Z"/>
            <rect style={j} x="260.91" y="405.74" width="14.82" height="33.7"/>
            <rect style={j} x="300.31" y="400.18" width="7.35" height="12.33"/>
            <rect style={j} x="308.87" y="400.18" width="7.35" height="12.33"/>
            <rect style={j} x="300.31" y="413.81" width="7.35" height="12.33"/>
            <rect style={j} x="308.87" y="413.81" width="7.35" height="12.33"/>
            <rect style={j} x="320.73" y="362.86" width="13.7" height="19.84"/>
            <rect style={j} x="342.7" y="362.86" width="13.7" height="19.84"/>
            <polygon style={j} points="358.71 403.89 345.01 403.89 331.31 403.89 331.31 427.26 345.01 427.26 358.71 427.26 372.41 427.26 372.41 403.89 358.71 403.89"/>
            <polygon style={l} points="260.81 356.22 260.81 361.49 259.5 361.49 259.5 382.69 226.28 382.69 226.28 361.49 224.97 361.49 224.97 356.22 260.81 356.22"/>
            <rect style={j} x="229.59" y="361.88" width="12.07" height="18.51"/>
            <rect style={j} x="244.13" y="361.88" width="12.07" height="18.51"/>
            <rect style={i} x="327.16" y="398.74" width="50.74" height="5.47"/>
            <rect style={i} x="319.36" y="382.7" width="16.44" height="2.74"/>
            <rect style={i} x="299.27" y="425.89" width="18.26" height="2.74"/>
            <rect style={i} x="341.33" y="382.7" width="16.44" height="2.74"/>
            <polygon style={i} points="260.81 356.22 260.81 361.49 259.5 361.49 259.5 361.54 226.28 361.54 226.28 361.49 224.97 361.49 224.97 356.22 260.81 356.22"/>
            </g>
        </g>
        <g>
            <polygon style={i} points="203.43 313.72 203.43 311.95 184.08 311.95 184.08 299.43 174.14 299.43 174.14 299.39 189.22 299.39 189.22 297.62 174.14 297.62 174.14 285.14 163.77 285.14 163.77 285.06 180.07 285.06 180.07 283.29 163.77 283.29 163.77 270.85 167.86 270.85 167.86 269.08 152.28 269.08 152.28 256.55 158.18 256.55 158.18 254.78 140.78 254.78 140.78 242.26 131.08 242.26 131.08 242.25 144.56 242.25 144.56 240.48 131.08 240.48 131.08 227.96 135.35 227.96 135.35 226.19 107.98 226.19 107.98 227.96 112.14 227.96 112.14 240.48 97.32 240.48 97.32 242.25 112.14 242.25 112.14 242.26 102.45 242.26 102.45 254.78 85.87 254.78 85.87 256.55 90.95 256.55 90.95 269.08 74.05 269.08 74.05 270.85 79.45 270.85 79.45 283.29 62.96 283.29 62.96 285.06 79.45 285.06 79.45 285.14 68.86 285.14 68.86 297.62 53.78 297.62 53.78 299.39 68.86 299.39 68.86 299.43 58.95 299.43 58.95 311.95 39.54 311.95 39.54 313.72 58.95 313.72 58.95 313.73 48.02 313.73 48.02 439.37 154.68 439.37 157.91 439.37 178.37 439.37 182.61 439.37 195.01 439.37 195.01 313.73 184.08 313.73 184.08 313.72 203.43 313.72"/>
            <g>
            <rect style={i} x="67.73" y="311.95" width="136.72" height="1.77"/>
            <rect style={i} x="79.6" y="297.62" width="112.99" height="1.77"/>
            <rect style={i} x="87.27" y="283.29" width="97.69" height="1.77"/>
            <rect style={i} x="96.51" y="269.08" width="78.26" height="1.77"/>
            <rect style={i} x="106.37" y="254.78" width="60.33" height="1.77"/>
            <rect style={i} x="115.93" y="240.48" width="39.42" height="1.77"/>
            <rect style={i} x="124.82" y="226.19" width="22.83" height="1.77"/>
            <polygon style={s} points="188.31 313.73 188.31 299.43 180.02 299.43 180.02 285.14 171.37 285.14 171.37 270.85 161.78 270.85 161.78 256.55 152.18 256.55 152.18 242.26 144.09 242.26 144.09 227.96 128.3 227.96 128.3 242.26 120.21 242.26 120.21 256.55 110.62 256.55 110.62 270.85 101.02 270.85 101.02 285.14 92.18 285.14 92.18 299.43 83.92 299.43 83.92 313.73 74.8 313.73 74.8 439.37 197.43 439.37 197.43 313.73 188.31 313.73"/>
            <path style={j} d="M110,294.84c-5.45,0-9.87,2.67-9.87,8.12v19.77h19.74V303C119.84,297.51,115.42,294.84,110,294.84Z"/>
            <path style={j} d="M136.11,294.84c-5.45,0-9.87,2.67-9.87,8.12v19.77H146V303C146,297.51,141.57,294.84,136.11,294.84Z"/>
            <path style={j} d="M162.26,294.84c-5.45,0-9.87,2.67-9.87,8.12v19.77h19.74V303C172.13,297.51,167.71,294.84,162.26,294.84Z"/>
            <rect style={p} x="82.16" y="352.5" width="10.21" height="15.59"/>
            <rect style={t} x="84.8" y="355.96" width="4.93" height="8.72"/>
            <rect style={p} x="179.86" y="352.5" width="10.21" height="15.59"/>
            <rect style={p} x="112.12" y="352.5" width="14.12" height="15.59"/>
            <rect style={p} x="145.99" y="352.5" width="14.12" height="15.59"/>
            <rect style={t} x="182.54" y="356.04" width="4.84" height="8.56"/>
            <rect style={t} x="149.19" y="355.96" width="7.59" height="8.72"/>
            <rect style={t} x="115.57" y="356.17" width="7.22" height="8.3"/>
            <rect style={j} x="92.37" y="381.65" width="19.75" height="48.45"/>
            <rect style={j} x="130.43" y="381.65" width="19.75" height="48.45"/>
            <polygon style={i} points="195.52 396.23 187.08 396.23 163.78 396.23 155.34 396.23 155.34 399.77 163.78 399.77 163.78 439.37 187.08 439.37 187.08 399.77 195.52 399.77 195.52 396.23"/>
            <rect style={j} x="166.48" y="404.35" width="17.07" height="35.02"/>
            <rect style={j} x="127.2" y="266.64" width="18.79" height="22.33"/>
            <rect style={i} x="135.69" y="238.98" width="1.05" height="13.62"/>
            <rect style={i} x="122.52" y="303.81" width="1.05" height="13.62"/>
            <rect style={i} x="148.66" y="303.81" width="1.05" height="13.62"/>
            <rect style={i} x="96.5" y="322.73" width="78.26" height="1.77"/>
            <rect style={i} x="80.05" y="430.1" width="78.26" height="1.77"/>
            <rect style={i} x="124.82" y="288.97" width="24.36" height="1.77"/>
            <rect style={i} x="78.94" y="368.09" width="114.31" height="1.77"/>
            <path style={j} d="M102.25,328.56c-5.46,0-9.88,2.66-9.88,8.12v31.41h19.75V336.68C112.12,331.22,107.7,328.56,102.25,328.56Z"/>
            <path style={j} d="M136.11,328.56c-5.45,0-9.87,2.66-9.87,8.12v31.41H146V336.68C146,331.22,141.57,328.56,136.11,328.56Z"/>
            <path style={j} d="M170,328.56c-5.45,0-9.87,2.66-9.87,8.12v31.41h19.75V336.68C179.86,331.22,175.44,328.56,170,328.56Z"/>
            </g>
        </g>
        <path style={u} d="M21.43,413.33H34.35a17.88,17.88,0,0,1,17.88,17.88v8.46a0,0,0,0,1,0,0H3.55a0,0,0,0,1,0,0v-8.46A17.88,17.88,0,0,1,21.43,413.33Z"/>
        <path style={u} d="M392.74,413.33h12.93a17.88,17.88,0,0,1,17.88,17.88v8.46a0,0,0,0,1,0,0H374.86a0,0,0,0,1,0,0v-8.46A17.88,17.88,0,0,1,392.74,413.33Z"/>
        <path style={h} d="M403.69,413.33h12.93a17.88,17.88,0,0,1,17.88,17.88v8.46a0,0,0,0,1,0,0H385.8a0,0,0,0,1,0,0v-8.46A17.88,17.88,0,0,1,403.69,413.33Z"/>
        <path style={u} d="M1120.47,413.33h12.93a17.88,17.88,0,0,1,17.88,17.88v8.46a0,0,0,0,1,0,0h-48.69a0,0,0,0,1,0,0v-8.46A17.88,17.88,0,0,1,1120.47,413.33Z"/>
        <path style={h} d="M1131.42,413.33h12.93a17.88,17.88,0,0,1,17.88,17.88v8.46a0,0,0,0,1,0,0h-48.69a0,0,0,0,1,0,0v-8.46A17.88,17.88,0,0,1,1131.42,413.33Z"/>
        <rect style={h} x="-1.16" y="439.37" width="1157.91" height="7.84"/>
        <g>
            <polyline style={o} points="908.98 440.12 921.97 440.12 930.77 440.12 945.58 440.12 1062.66 440.12 1062.66 430.12 1062.66 396.83 1066.59 396.83 1079.4 396.83 1025.37 332.78 1037.62 313.5 1009.11 313.5 983.45 343.38 904.56 343.38"/>
            <polyline style={i} points="904.56 343.38 879.07 400.85 879.07 402.38 879.07 430.12 879.07 440.12 887.07 440.12 908.98 440.12"/>
            <g>
            <polygon style={p} points="1107.92 396.83 1091.17 396.83 1012.82 368.82 1012.82 400.85 904.56 400.85 904.56 343.38 1011.96 343.38 1037.62 313.5 1107.92 396.83"/>
            <polygon style={q} points="1095.1 396.83 1091.17 396.83 1091.17 430.12 907.59 430.12 907.59 402.38 978.91 402.38 978.91 398.23 1037.59 328.37 1095.1 396.83"/>
            <polygon style={l} points="1091.17 396.83 1091.17 430.12 907.59 430.12 907.59 400.64 983.56 400.64 983.56 396.83 1037.37 332.78 1091.17 396.83"/>
            <rect style={i} x="907.59" y="430.12" width="183.58" height="10"/>
            <path style={r} d="M933,404.88c-9.64,0-17.45,6.09-17.45,7.38v27.86h34.91V412.26C950.49,411,942.67,404.88,933,404.88Z"/>
            <rect style={j} x="959.28" y="406.42" width="14.82" height="33.7"/>
            <rect style={j} x="998.68" y="400.85" width="7.35" height="12.33"/>
            <rect style={j} x="1007.24" y="400.85" width="7.35" height="12.33"/>
            <rect style={j} x="998.68" y="414.48" width="7.35" height="12.33"/>
            <rect style={j} x="1007.24" y="414.48" width="7.35" height="12.33"/>
            <rect style={j} x="1019.1" y="363.53" width="13.7" height="19.84"/>
            <rect style={j} x="1041.07" y="363.53" width="13.7" height="19.84"/>
            <polygon style={j} points="1057.08 404.56 1043.38 404.56 1029.68 404.56 1029.68 427.94 1043.38 427.94 1057.08 427.94 1070.78 427.94 1070.78 404.56 1057.08 404.56"/>
            <polygon style={l} points="959.18 356.9 959.18 362.17 957.88 362.17 957.88 383.37 924.65 383.37 924.65 362.17 923.35 362.17 923.35 356.9 959.18 356.9"/>
            <rect style={j} x="927.96" y="362.55" width="12.07" height="18.51"/>
            <rect style={j} x="942.5" y="362.55" width="12.07" height="18.51"/>
            <rect style={i} x="1025.53" y="399.41" width="50.74" height="5.47"/>
            <rect style={i} x="1017.73" y="383.37" width="16.44" height="2.74"/>
            <rect style={i} x="997.65" y="426.57" width="18.26" height="2.74"/>
            <rect style={i} x="1039.7" y="383.37" width="16.44" height="2.74"/>
            <polygon style={i} points="959.18 356.9 959.18 362.17 957.88 362.17 957.88 362.21 924.65 362.21 924.65 362.17 923.35 362.17 923.35 356.9 959.18 356.9"/>
            </g>
        </g>
        <rect style={v} x="-1.16" y="447.21" width="1157.91" height="24.97"/>
        <g>
            <polygon style={w} points="844.8 176.14 887.83 176.14 873.16 197.64 828.08 207.21 844.8 176.14"/>
            <polygon style={w} points="737.18 267.95 737.18 264.01 737.18 224.49 737.18 224.49 737.18 219.27 844.8 176.14 844.8 181.35 787.64 204.27 844.81 181.36 844.81 371.88 858.04 371.88 858.04 376.14 853.55 376.14 853.55 440.14 844.81 440.14 837.24 440.14 832.71 440.14 807.93 440.14 803.38 440.14 778.6 440.14 737.42 440.14 737.18 440.14 712.64 440.14 684.07 440.14 684.07 271.89 678.07 271.89 678.07 267.95 737.18 267.95"/>
            <g>
            <polygon style={x} points="780.21 440.14 880.27 440.14 887.83 440.14 896.58 440.14 896.58 376.14 887.83 376.14 887.83 181.36 780.21 224.49 780.21 264.01 780.21 440.14"/>
            <polygon style={x} points="780.21 440.14 880.27 440.14 887.83 440.14 896.58 440.14 896.58 376.14 887.83 376.14 887.83 181.36 780.21 224.49 780.21 264.01 780.21 440.14"/>
            <polygon style={n} points="780.21 219.27 780.21 224.49 887.83 181.35 887.83 176.14 780.21 219.27"/>
            <rect style={y} x="727.1" y="271.9" width="53.11" height="168.25" transform="translate(1507.3 712.04) rotate(-180)"/>
            <rect style={n} x="850.96" y="379.68" width="24.78" height="60.46" transform="translate(1726.7 819.83) rotate(-180)"/>
            <rect style={n} x="821.63" y="379.68" width="24.78" height="60.46" transform="translate(1668.04 819.83) rotate(-180)"/>
            <rect style={j} x="826.62" y="385.33" width="14.79" height="42.63" transform="translate(1668.04 813.28) rotate(-180)"/>
            <rect style={j} x="855.95" y="385.33" width="14.79" height="42.63" transform="translate(1726.7 813.28) rotate(-180)"/>
            <rect style={n} x="755.67" y="379.68" width="24.78" height="60.46" transform="translate(1536.12 819.83) rotate(-180)"/>
            <rect style={n} x="786.42" y="365.5" width="90.53" height="6.38" transform="translate(1663.38 737.39) rotate(-180)"/>
            <rect style={j} x="844.34" y="320.83" width="21.98" height="44.68" transform="translate(1710.66 686.33) rotate(-180)"/>
            <rect style={j} x="844.34" y="271.9" width="21.98" height="44.68" transform="translate(1710.66 588.47) rotate(-180)"/>
            <rect style={j} x="844.34" y="222.96" width="21.98" height="44.68" transform="translate(1710.66 490.6) rotate(-180)"/>
            <rect style={n} x="841.57" y="348.89" width="28.09" height="3.63" transform="translate(1711.24 701.41) rotate(-180)"/>
            <rect style={n} x="841.28" y="313.61" width="28.09" height="3.63" transform="translate(1710.66 630.85) rotate(-180)"/>
            <rect style={n} x="730.43" y="343.16" width="49.77" height="3.63" transform="translate(1510.64 689.96) rotate(-180)"/>
            <rect style={n} x="841.28" y="264.68" width="28.09" height="3.63" transform="translate(1710.66 532.99) rotate(-180)"/>
            <rect style={n} x="832.95" y="357.51" width="20.89" height="3.63" transform="translate(1202.72 -484.06) rotate(90)"/>
            <rect style={n} x="857.41" y="357.51" width="20.89" height="3.63" transform="translate(1227.18 -508.52) rotate(90)"/>
            <rect style={n} x="841.57" y="357.19" width="28.09" height="3.63" transform="translate(1711.24 718.02) rotate(-180)"/>
            <rect style={j} x="752.11" y="303.24" width="28.09" height="39.93" transform="translate(1532.32 646.4) rotate(-180)"/>
            <rect style={j} x="733.36" y="303.24" width="12.9" height="39.93" transform="translate(1479.61 646.4) rotate(-180)"/>
            <rect style={j} x="768.66" y="385.33" width="7.41" height="43.04" transform="translate(1544.73 813.7) rotate(-180)"/>
            <rect style={x} x="721.1" y="267.95" width="59.11" height="3.94" transform="translate(1501.31 539.85) rotate(-180)"/>
            <rect style={n} x="887.83" y="371.89" width="13.24" height="4.25" transform="translate(1788.9 748.03) rotate(-180)"/>
            </g>
        </g>
        <rect style={z} x="-9" y="-1" width="1172" height="219"/>
        <rect style={aa} x="-3" y="-31" width="1158" height="1977"/>
        <rect style={ab} x="-3" y="466" width="1158" height="9"/>
        <path style={h} d="M32.37,413.33H45.3a17.88,17.88,0,0,1,17.88,17.88v8.46a0,0,0,0,1,0,0H14.49a0,0,0,0,1,0,0v-8.46A17.88,17.88,0,0,1,32.37,413.33Z"/>
        <path style={g} d="M667.73,411h4.48c17.4,0,35.74-14.74,35.74-32.92l-4.24-69.86c0-18.18-14.1-32.92-31.5-32.92h-4.48c-17.39,0-31.49,14.74-31.49,32.92L632,378.08C632,396.26,650.34,411,667.73,411Z"/>
        <g>
            <path style={g} d="M669.73,413.13h4.48c17.4,0,35.74-14.1,35.74-31.49l-4.24-66.85a31.49,31.49,0,0,0-31.5-31.49h-4.48a31.49,31.49,0,0,0-31.49,31.49L634,381.64C634,399,652.34,413.13,669.73,413.13Z"/>
            <rect style={h} x="638.24" y="276.07" width="67.47" height="129.83" rx="33.73" transform="translate(1343.95 681.98) rotate(180)"/>
            <path style={i} d="M672,441.61a2,2,0,0,0,2-2V332.8a2,2,0,0,0-4,0V439.59A2,2,0,0,0,672,441.61Z"/>
            <path style={i} d="M672,398.39A22.09,22.09,0,0,0,694,376.33v-7a2,2,0,0,0-4,0v7a18.06,18.06,0,0,1-18,18,2,2,0,0,0,0,4Z"/>
            <path style={i} d="M672,365.26a2,2,0,1,0,0-4,18.06,18.06,0,0,1-18-18v-7a2,2,0,0,0-4,0v7A22.08,22.08,0,0,0,672,365.26Z"/>
        </g>
        </svg>;
}

export default Header;


// WEBPACK FOOTER //
// ./src/elements/header.js